.wrapper {
  display: flex;
  flex-direction: column;
  flex: 1;
  padding: 0 0 2rem 3.5rem;
}

.inner {
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 1.2rem 0 0 0;
}

.leftBorder {
  display: flex;
  position: absolute;
  width: 4px;
  height: 100%;
  background: linear-gradient(
    180deg,
    var(--primary-gradient1) -18.54%,
    var(--primary-gradient2) 99.84%
  );
}

.inner > .left {
  width: 50%;
  max-width: 500px;
}

.left {
  display: flex;
  align-items: center;
  flex: 1.3;
}

.right {
  display: flex;
  align-items: center;
  flex: 1;
}

.item {
  display: flex;
  align-items: center;
  flex: 1;
  padding-right: 16px;
}

.label {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding-top: 4px;
  font-weight: 500;
  gap: 4px;
}

.inputDetails {
  width: 250px;
  margin-right: 2rem;
}

.cancelButton {
  height: 45px;
  width: 100px;
  font-size: 14px;
  justify-content: center;
}

.confirmButton {
  height: 45px;
  width: 160px;
  font-size: 14px;
}

@media screen and (max-width: 768px) {
  .rowLevel,
  .rowLeft,
  .rowRight {
    flex-direction: column;
    align-items: flex-start;
  }
}

.list {
  list-style: circle;
  margin: 16px;
}

.list > li {
  margin: 8px 0;
}

.treatmentTypeTitle {
  font-style: 18px;
  font-weight: 500;
  line-height: 23.4px;
  margin: 0;
  color: var(--black);
}

.treatmentTypeContainer {
  display: flex;
  flex-direction: column;
}

.treatmentTypeOptionsContainer {
  display: flex;
  flex-direction: column;
}

.formContainer {
  display: flex;
  gap: 32px;
  justify-content: space-between;
}
